import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page69() {
  useEffect(() => {
    document.title = "Маяк — Страница 68"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page67" />
        <ForwardLink href="/page69" />
      </div>

      <p style={{ textAlign: "right" }}>68.</p>
      <p>НАЗАД В САРАЙ: МОЛОДОЙ ОХВАЧЕН УЖАСОМ.</p>
      <p>
        ОБРАТНО НА СКАЛЫ: ВНУТРИ ЛОВУШКИ <u>СМОРЩЕННАЯ</u><br/>
        <u>ГОЛОВА</u> <u>ЧЕЛОВЕКА</u> <u>с</u> <u>ОДНИМ ГЛАЗОМ</u>.
      </p>
      <p><u>ЧАЙКА</u> ПРОЛЕТАЕТ РЯДОМ С МОЛОДЫМ, КРИЧИТ, КАК МОЖЕТ!</p>
      <p>МОЛОДОЙ ЧУТЬ НЕ УПАЛ В ВОДУ ОТ УЖАСА.</p>
      <p>МАЛЕНЬКИЕ КРАБЫ ВЫПОЛЗАЮТ ИЗ ПУСТОЙ ГЛАЗНИЦЫ.</p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КАМБУЗ – НОЧЬ</p>
      <p>ГРЕМИТ ГРОМ.</p>
      <p>
        МОЛОДОЙ И СТАРИК поют, танцуют, пляшут, раскручивая<br/>
        друг друга по комнате, сцепившись локтями.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        (поет)<br/>
        <i>Она покачивала бедрами, подмигивала,<br/>
        эта нахальная маленькая шлюха,<br/>
        Так что я взял ее к себе, дал ей джин<br/>
        и танцевал с ней на полу!</i>
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ И СТАРИК<br/>
        (поют)<br/>
        <i>Дура, отпусти меня, к девчонкам, дура,<br/>
        отпусти меня,<br/>
        Ура, мне девушек повыше, дура, отпусти<br/>
        меня!</i>
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        (поет)<br/>
        <i>О, вокруг и вокруг дивана,<br/>
        ребята, разве это не шоу?<br/>
        Она схватила меня за бобштаг и<br/>
        не отпускала!</i>
      </p>
      <p>Они смеются и вырываются друг от друга...</p>
      <p>
        СТАРИК начинает диддлинг “Ten Penny Bit” и танцевать джигу.<br/>
        (Диддлинг — это разновидность военно-морского джазового пения, имитирующего<br/>
        скрипку)
      </p>
      <p>
        МОЛОДОЙ хлопает, пока СТАРИК танцует. Его танец впечатляет,<br/>
        особенно с его больной ногой. <i>Как это возможно?</i>
      </p>
      <p>МОЛОДОЙ присоединяется к диддлингу и джиге...</p>
      <p>
        СТАРИК тоже начинает хлопать. Он хлопает немного быстрее, МОЛОДОЙ<br/>
        подстраивается под его темп.
      </p>
      <p style={{ textAlign: "right" }}>68.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page67" />
        <ForwardLink href="/page69" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710633327/the-lighthouse-script/w76prq9klvttgk4ruetq.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page69;
